export default {
      id: "ic_trash_orange-usage",
      viewBox: "0 0 32 32",
      url: "/" + "images/icons.3.109.2.svg#ic_trash_orange-usage",
      toString: function () {
        return this.url;
      }
    }